import React from 'react';
import { MultiPortfolioReviewComponents } from '../common/MultiPortfolioReviewComponents';
import { useMultiHistoricalRightPaneContent } from '../../hooks/useMultiHistoricalRightPaneContent';

export const Content = () => {
  const { autoGroupColumnDefs, columnDefs, rowData, rowClassRules, getRowId } = useMultiHistoricalRightPaneContent();
  return (
    <MultiPortfolioReviewComponents.RightSideBarContent
      autoGroupColumnDefs={autoGroupColumnDefs}
      columnDefs={columnDefs}
      rowData={rowData}
      rowClassRules={rowClassRules}
      getRowId={getRowId}
    />
  );
};
